// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function slowly<T extends () => Promise<any>>(fn: T, duration = 800): Promise<ReturnType<T>> {
  let err: unknown;
  let result: ReturnType<T> = undefined as ReturnType<T>;

  const start = Date.now();
  try {
    result = await fn();
  } catch (e) {
    err = e;
  }

  // sleep if necessary
  const sleep = duration - (Date.now() - start);
  if (sleep > 0) {
    await delay(sleep);
  }

  // done
  if (err) {
    throw err;
  }
  return result;
}
